import React from 'react';
import { Link } from 'react-router-dom';
import { Flame } from 'lucide-react';

export default function TrendingList({ items = [] }) {
  if (!items.length) return null;
  return (
    <div className="rounded-xl overflow-hidden border border-[#e3ece7] bg-white shadow-sm">
      <div className="px-4 py-3 flex items-center gap-2 text-white" style={{ background: 'linear-gradient(135deg, #157347, #0b3d26)' }}>
        <Flame className="w-4 h-4 text-[#8be0b0]" />
        <span className="font-cond font-bold uppercase tracking-wider text-sm">Trending in Michigan</span>
      </div>
      <ul>
        {items.slice(0, 6).map((a, i) => (
          <li key={a.id} className="border-b border-[#eef2f0] last:border-0">
            <Link to={`/article/${a.id}`} className="group flex gap-3 px-4 py-3 hover:bg-[#f7fbf9] transition-colors">
              <span className="font-display font-extrabold text-2xl text-[#bcd6c8] leading-none w-7 shrink-0">{i + 1}</span>
              <span className="text-[14px] font-medium leading-snug text-[#14241d] clamp-2 group-hover:text-[#157347] transition-colors">{a.title}</span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
